(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('AgentCategoryAccessSearch', AgentCategoryAccessSearch);

    AgentCategoryAccessSearch.$inject = ['$resource'];

    function AgentCategoryAccessSearch($resource) {
        var resourceUrl = 'api/_search/agent-category-accesses/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
